<template>
<div class="right-panel-container-list">
  <div class="simple-tab-container  simple-tab-theme-badge">
    <ul class="simple-tab ">
      <li @click="selectItem('order')" class="tab-item" :class="{'selected': activeItem == 'order'}" >
        <font style="vertical-align: inherit;">
          <font  style="vertical-align: inherit;">订单</font></font>
      </li>
      <li @click="selectItem('product')" class="tab-item" :class="{'selected': activeItem == 'product'}" >
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;" >产品</font></font>
      </li>
      <li @click="selectItem('voucher')" class="tab-item" :class="{'selected': activeItem == 'voucher'}" >
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;" >代金券</font></font>
      </li>
    </ul>

  </div>
  <div style="height: 100%;" ref="sideContainer" id="sideContainer" class="content">

    <div v-show="activeItem == 'order'" class="lzd-panel-order">
      <div class="order-info-panel">
        <div style="margin: 8px 16px;">
        
          <Input>
              <Select slot="prepend" style="width: 80px">
                  <Option value="">全部</Option>
              </Select>
              <Button slot="append" icon="ios-search"></Button>
          </Input>
        </div>
        <div class="simple-loader">
          <div class="simple-placeholder">
            <Scroll  v-if="order && order.data && order.data.length > 0 && currentSession" :height="sideScroll" :on-reach-bottom="getMoreOrder">
              <List size="small">
                <ListItem v-for="(item, i) in order.data" :key="i">
                  <div class="lzd-order-item">
                    <div class="order-header">
                      <div class="header-item-info">
                          <div class="header-item-status">
                            {{item.order_status}}
                          </div>
                          <div class="header-item-createtime">
                            {{item.created_at}}
                          </div>
                      </div>
                      <div class="header-item-order">
                        <div class="header-item-orderid">{{item.ordersn}}</div>
                        <Icon @click="onCopy(item.ordersn)" size="15" color="#8ea4d1" type="md-copy" />
                      </div>
                      <div>
                        {{item.payment_method}}
                      </div>
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="clip-list order-detail">
                      <div class="content">
                        <div class="sub-order-item" v-for="(orderItem, index) in item.products" :key="index">
                          <div v-if="index <= 1 || item.moreshow" class="item__body">
                            <img class="item__pic" :src="orderItem.item_image">
                            <div class="item__info">
                              <p style="cursor: pointer;" @click="winControl.openURL(orderItem.product_detail_url)" class="title text-overflow">
                                <font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;">{{orderItem.item_name}}</font></font>
                              </p>
                              <p class="properties">
                                <font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;">{{orderItem.item_sku}}</font></font>
                              </p>
                              <p class="price-info">
                                <span class="price">
                                  <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">{{orderItem.paid_price}}</font></font>
                                </span>
                                <span class="count">
                                  <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">× {{orderItem.item_quantity}}</font></font>
                                </span>
                              </p>
                              <p v-if="item.review && item.review.length > 0" class="review-info">
                                <Rate disabled :value="item.review[0].overall_rating" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div @click="moreshow(i)" v-show="item.products.length > 2" class="more-item">
                        <a class="clip-toggle">
                          {{ item.moreshow ? '收起' : '查看更多' }}
                        </a>
                      </div>
                    </div>
                    <div v-if="item.reverse" class="reverse-order-wrap">
                      <div class="reverse-refund-type">{{ item.reverse.request_type }}</div>
                      <div class="reverse-order-content">
                        <div class="operate-wrap">
                          <div class="reverse-order-status">{{ item.reverse.reverse_status }}</div>
                          <button @click="refundConfirm(item.reverse.reverse_order_id)">同意退款</button>
                        </div>
                        <div class="reverse-order-info-wrap">
                          <div class="reverse-order-info">
                            <p>更新时间：{{ item.reverse.return_update_time }}</p>
                            <p>退款原因：{{ item.reverse.reason_text }}</p>
                            <p>{{ item.reverse.reverse_order_id }}</p>
                          </div>
                          <div class="reverse-order-icon">
                            
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="order-section">
                      
                      <div class="section-item">
                        <div class="section-item-label">
                          物流
                        </div>
                        <div class="section-item-content">
                          <a @click="showTraceModal(item)">查看物流</a>
                        </div>
                      </div>
                      <div class="section-item">
                        <div class="section-item-label">
                          买家名
                        </div>
                        <div class="section-item-content">
                          <a>{{item.buyer_username}}</a>
                        </div>
                      </div>
                      <div v-if="item.aftersale" class="section-item">
                        <div class="section-item-label">
                          售后备注
                        </div>
                        <div class="section-item-content">
                          <a>{{item.aftersale.remark}}</a>
                        </div>
                      </div>
                      <div v-if="item.review" class="section-item">
                        <div class="section-item-label">
                          差评备注
                        </div>
                        <div class="section-item-content">
                          <a>{{item.review.remark}}</a>
                        </div>
                      </div>
                      
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="order-footer">
                      
                      <div class="order-actions">
            
                        
                        <button v-if="item.aftersale" @click="appendRemarkModalShow(item.aftersale.id);" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">追加备注</font></font>
                        </button>
                        <button v-if="!item.aftersale" @click="addSalesModalShow(item);" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">添加售后</font></font>
                        </button>
                        <button @click="buyer_info(item)" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">客户资料</font></font>
                        </button>
                        <button @click="order_send(item)" type="button" class="im-components-btn im-components-btn-primary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">发送</font></font>
                        </button>
                      </div>
                    </div>
                  </div>
                </ListItem>
              </List>
            <div v-if="(order.current_page >= order.last_page && order.total != 0)" class="scroll-nomore">没有更多了</div>
            </Scroll>
            <Empty :load="order.load"></Empty>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div v-show="activeItem == 'product'" class="lzd-panel-product">
      <div class="order-info-panel">
        <div style="margin: 8px 16px;">
        
          <Input v-model="product_input" style="width: 250px">
              <Select v-model="product_select" slot="prepend" style="width: 80px">
                  <Option value="">全部</Option>
                  <Option value="item_id">商品id</Option>
                  <Option value="seller_sku">卖家sku</Option>
                  <Option value="title">标题</Option>
              </Select>
              <Button @click="getProduct()" slot="append" icon="ios-search"></Button>
          </Input>
        </div>
        <div class="simple-loader">
          <div class="simple-placeholder productList">
              <Scroll v-if="product && product.data && product.data.length > 0" :height="sideScroll" :on-reach-bottom="getMoreProduct" :distance-to-edge="-20">
            <List size="small">
                <ListItem v-for="(item, index) in product.data" :key="index">
                  <div class="item__wrapper product">
                    <div class="item__info">
                      <div class="background-default item__pic" :style="{ 'backgroundImage':'url('+ item.images[0] +')'}" ></div>
                      <div class="item__desc">
                        <div class="item__row">
                          <div class="text-overflow" :title="item.product_title">{{item.product_title}}</div>
                         </div>
                        <div class="item__row">
                          <div class="item__sku text-overflow" title="C28-">{{item.seller_sku}}</div></div>
                          <div style="justify-content: flex-start;align-items: center;" class="item__row">
                            <span style="font-size: 14px;color: #1a71ff;font-weight: 500;">{{item.special_price}} {{item.currency}}</span>
                            <div class="separator"></div>    
                            stock {{item.stock}}
                          </div>
                      </div>
                    </div>
                    <div class="item__ops">
                      <button @click="winControl.openURL((item.url))" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">查看</button>
                      <button @click="product_send(item)" type="button" class="im-components-btn im-components-btn-primary im-components-btn-medium">发送</button>
                      <button @click="setWeight(item)" class="im-components-btn im-components-btn-secondary"><Icon type="md-arrow-round-up" />置顶</button>
                      
                    </div>
                  </div>
                </ListItem>
            </List>
            <div v-if="(product.current_page >= product.last_page && product.total != 0)" class="scroll-nomore">没有更多了</div>
              </Scroll>
            <Empty :load="product.load"></Empty>
          </div>
        </div>
      </div>
    </div>


    <div v-show="activeItem == 'voucher'" class="im-voucher-section">
      <div class="simple-tab-container  simple-tab-theme-underline">
        <ul class="simple-tab voucher-tab" >
          <li @click="selectTab('CODE_VOUCHER')" class="tab-item" :class="{'selected': voucherType == 'CODE_VOUCHER'}" >
            <font style="vertical-align: inherit;" >
              <font style="vertical-align: inherit;" >活动</font></font>
          </li>
          <li @click="selectTab('COLLECTIBLE_VOUCHER')" class="tab-item" :class="{'selected': voucherType == 'COLLECTIBLE_VOUCHER'}" >
            <font style="vertical-align: inherit;" >
              <font style="vertical-align: inherit;" >收藏品</font></font>
          </li>
        </ul>
        <List v-if="voucher.voucher_list && voucher.voucher_list.length > 0" size="small">
          <Scroll :height="sideScroll" >
            <ListItem v-for="(item, i) in voucher.voucher_list" :key="i">
              <div class="voucher-item">
                <div class="voucher-item-hd">
                  <div class="voucher-item-price">
                    <svg class="im-icon" width="21px" height="12px" viewBox="0 0 21 12" version="1.1"><g stroke="#f51c43" stroke-width="1" fill="#f51c43" fill-rule="evenodd"><g class="im-icon-voucher-fill" transform="translate(-71.000000, -954.000000)" fill-rule="nonzero"><g transform="translate(43.000000, 610.000000)"><g transform="translate(0.000000, 317.000000)"><g transform="translate(16.000000, 10.000000)"><path d="M12.75,17 L32.25,17 C32.6398481,17 32.9602243,17.297444 32.9965667,17.67777 L33,17.75 L33,21.25 C33,21.6398481 32.702556,21.9602243 32.32223,21.9965667 L32.1753686,22.0027429 C31.6579374,22.0409173 31.25,22.4728175 31.25,23 C31.25,23.5271825 31.6579374,23.9590827 32.1753686,23.9972571 L32.32223,24.0034333 C32.6787856,24.0375043 32.9624957,24.3212144 32.9965667,24.67777 L33,24.75 L33,29 L31.5,29 L31.5,25.3855498 C30.4857225,25.0669844 29.75,24.119412 29.75,23 C29.75,21.9191884 30.4358578,20.9985697 31.3960871,20.6496303 L31.5,20.6144502 L31.5,18.5 L13.5,18.5 L13.5,20.6144502 C14.5142775,20.9330156 15.25,21.880588 15.25,23 C15.25,24.0808116 14.5641422,25.0014303 13.6039129,25.3503697 L13.5,25.3855498 L13.5,27.5 L31.8585553,27.5 L31.8585553,29 L12.75,29 C12.3601519,29 12.0397757,28.702556 12.0034333,28.32223 L12,28.25 L12,24.75 C12,24.3601519 12.297444,24.0397757 12.67777,24.0034333 L12.8246314,23.9972571 C13.3420626,23.9590827 13.75,23.5271825 13.75,23 C13.75,22.4728175 13.3420626,22.0409173 12.8246314,22.0027429 L12.67777,21.9965667 C12.3212144,21.9624957 12.0375043,21.6787856 12.0034333,21.32223 L12,21.25 L12,17.75 C12,17.3601519 12.297444,17.0397757 12.67777,17.0034333 L12.75,17 L32.25,17 L12.75,17 Z M25,25.8299559 C25.414,25.8299559 25.75,26.1659559 25.75,26.5799559 C25.75,26.9939559 25.414,27.3299559 25,27.3299559 C24.586,27.3299559 24.25,26.9939559 24.25,26.5799559 C24.25,26.1659559 24.586,25.8299559 25,25.8299559 Z M25,23.5910388 C25.414,23.5910388 25.75,23.9270388 25.75,24.3410388 C25.75,24.7550388 25.414,25.0910388 25,25.0910388 C24.586,25.0910388 24.25,24.7550388 24.25,24.3410388 C24.25,23.9270388 24.586,23.5910388 25,23.5910388 Z M24.983859,21.3119756 C25.397859,21.3119756 25.733859,21.6479756 25.733859,22.0619756 C25.733859,22.4759756 25.397859,22.8119756 24.983859,22.8119756 C24.569859,22.8119756 24.233859,22.4759756 24.233859,22.0619756 C24.233859,21.6479756 24.569859,21.3119756 24.983859,21.3119756 Z M25,19 C25.414,19 25.75,19.336 25.75,19.75 C25.75,20.164 25.414,20.5 25,20.5 C24.586,20.5 24.25,20.164 24.25,19.75 C24.25,19.336 24.586,19 25,19 Z"></path></g></g></g></g></g></svg>
                    <span>
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">-{{item.offering_money_value_off}} {{item.currency}}</font></font>
                    </span>
                  </div>
                  <button @click="voucher_send(item)" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">发送</font></font>
                  </button>
                </div>
                <div class="voucher-item-bd">
                  <p class="voucher-item-line">
                    <label class="voucher-item-line__label">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">Name:</font></font>
                    </label>
                    <p class="voucher-item-line__field">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">{{item.voucher_name}}</font></font>
                    </p>
                  </p>
                  <p class="voucher-item-line">
                    <label class="voucher-item-line__label">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">时间：</font></font>
                    </label>
                    <p class="voucher-item-line__field">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">{{formatDate(item.period_start_time)}} - {{formatDate(item.period_end_time)}}</font></font>
                    </p>
                  </p>
                  <p class="voucher-item-line">
                    <label class="voucher-item-line__label">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">类型：</font></font>
                    </label>
                    <p class="voucher-item-line__field">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">{{item.voucher_type == 'COLLECTIBLE_VOUCHER' ? '可收藏' : ''}}</font></font>
                    </p>
                  </p>
                  <p class="voucher-item-line">
                    <label class="voucher-item-line__label">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">状态：</font></font>
                    </label>
                    <p class="voucher-item-line__field">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">{{item.status}}</font></font>
                    </p>
                  </p>
                </div>
              </div>
            </ListItem>
          </Scroll>
        </List>
        <Empty :load="voucher.load"></Empty>
      </div>
      
    </div>

  </div>
<Modal
    v-model="traceModal"
    title="物流状态"
    :footer-hide="true"
    width="800"
    >
  <OrderTrace :orderId="orderId"></OrderTrace>
</Modal>

<Modal 
  v-model="addSalesModal"
  title="添加售后"
  :footer-hide="true"
  width="400"
  >
   <Form :model="salesForm" :label-width="80">
    <FormItem label="订单类型">
      <Select v-model="salesForm.type" style="width:200px">
            <Option :value="1">常规</Option>
            <Option :value="2">退款</Option>
            <Option :value="3">紧急</Option>
            <Option :value="4">补发</Option>
            <Option :value="5">私下退换</Option>
        </Select>
    </FormItem>
    <FormItem label="备注">
      <EditorTool toref="saleEditor" ref="saleEditorElem"></EditorTool>
      
    </FormItem>
    <FormItem>
        <Button @click="aftersaleAdd()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

<Modal
    v-model="appendRemarkModal"
    title="备注"
    :footer-hide="true"
    @on-cancel="appendRemarkModal = false">

 <div>
   <div class="remark-trace">
     <ul class="date-line">
       <li v-for="(item, index) in remarkList" :key="index" class="date-item">{{item.create_time_text}}</li>
     </ul>
     <Timeline>
         <TimelineItem style="height: 100px;" v-for="(item, index) in remarkList" :key="index">
           <div>              
            <pre @click="triggerClick" class="context-wrap" v-html="item.remark"></pre>
            <span style="font-size: 10px;" v-if="item.user">跟进人: {{item.user.username}}</span>
           </div>
         </TimelineItem>
     </Timeline>
   </div>
   <Divider />
   <div>
      <Form :model="remarkFormItem" :label-width="80">
        <FormItem label="订单类型">
            <Select @on-change="(val)=>setSaleType(val, remarkFormItem.aftersale_id)" v-model="remarkFormItem.saleType" style="width:200px">
                  <Option :value="1">常规</Option>
                  <Option :value="2">退款</Option>
                  <Option :value="3">紧急</Option>
                  <Option :value="4">补发</Option>
                  <Option :value="5">私下退换</Option>
              </Select>
          </FormItem>
        <FormItem label="订单状态">
          <Select @on-change="(val)=>setSaleStatus(val, remarkFormItem.aftersale_id)" v-model="remarkFormItem.orderStatus" style="width:200px">
            <Option :value="0">待处理</Option>
            <Option :value="1">已完成</Option>
          </Select>
       </FormItem>
       <FormItem label="备注">
           <EditorTool toref="remarkEditor" ref="remarkEditorElem"></EditorTool>
       </FormItem>
       <FormItem>
           <Button @click="addRemark()" type="primary">添加</Button>
       </FormItem>
     </Form>
   </div>
 </div>
</Modal>
<Modal
    v-model="preview.previewModal"
    :footer-hide="true"
    width="600"
    >
  <img style="max-width: 500px;" :src="preview.previewImgurl">
</Modal>

</div>
</template>

<script>
const { scrollBottom,formatDateTime } = require("../../../../utils/ChatUtils");
import conf from "../../conf";
import RequestUtils from "../../../../utils/RequestUtils";
import MsgUtils from '@/utils/MsgUtils';
import Empty from "../empty.vue";
import OrderTrace from "./orderTrace.vue";
import EditorTool from '../common/editorTool';


export default {
  components: {
    Empty,
    OrderTrace,
    EditorTool
  },
  data() {
    return {

      activeItem: 'order',
      voucherType: 'CODE_VOUCHER',
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      sideScroll: 500,
      product_select: '',
      product_input: '',
      traceModal: false,
      orderId: '',
      addSalesModal: false,
      salesForm: {
        id: '',
        type: 1,
        remark: ''
      },
      appendRemarkModal: false,
      remarkList: [],
      remarkFormItem: {
        aftersale_id: '',
        remark: '',
        orderStatus: 0,
        saleType: 1,
      },
      preview: {
        previewModal: false,      
        previewImgurl: '',
      },
    };
  },
  props: ["chat"],
  mounted: function() {
    this.sideScroll = document.querySelector('body').offsetHeight - 64 - 36 - 203 - 56 - 48;
  },
  computed: {
    currentStore: {
      get: function () {
        return this.$store.state.lazada.currentStore;
      }
    },
    currentSession: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.currentSessionData[seller_id];
      }
    },
    order: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.orderData[seller_id] || {};
      }
    },
    product: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.productData[seller_id] || {};
      }
    },
    voucher: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.voucherData[seller_id] || {};
      }
    },
    chatBoxElem: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        console.log(document.getElementById('sellerchat_'+seller_id).querySelector('.ivu-scroll-content'));
        return document.getElementById('sellerchat_'+seller_id).querySelector('.ivu-scroll-content');
      }
    }
  },
  methods: {
    triggerClick(event) {
      if (event.target.nodeName == 'IMG') {
        this.preview.previewModal = true;
        this.preview.previewImgurl = event.target.src;
      }
    },
    showTraceModal (item) {
      this.traceModal = true;
      this.orderId = item.ordersn;
    },
    formatDate(timestamp) {
      return formatDateTime(new Date(timestamp*1));
    },
    moreshow(index) {
      this.$store.commit("lazada/orderMoreShow", index);
    },
    onCopy(text) {
      this.$copyText(text).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    selectItem(select) {
      this.activeItem = select;
      if (select == 'order') {
        this.getOrder();
      } else if (select == 'product') {
        this.getProduct();
      } else if (select == 'voucher') {
        this.getVoucher();
      }
    },
    selectTab(select) {
      this.voucherType = select;
      this.getVoucher();
    },
    /**
     * 发送产品
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    product_send (item) {
      let self = this;
      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("session_id", self.currentSession.session_id);
      param.set("connector", 'lazada');
      param.set("template_id", 10006);
      param.set("item_id", item.item_id);

      param.set("title", item.product_title);      
      param.set("price", "THB"+item.special_price);      
      param.set("oldPrice", "THB"+item.price);      
      param.set("discount", "-"+(item.special_price/item.price).toFixed(2)+"%");      
      param.set("iconUrl", item.images[0]);      
      param.set("actionUrl", item.url);      
      MsgUtils.request(this, param).then(() => {
        scrollBottom(self, this.chatBoxElem);
      })
    },

    /**
     * 产品列表
     * @param  {Number} page [description]
     * @return {[type]}      [description]
     */
    getProduct (page = 1) {
      let self = this;
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", self.currentStore.id);
      if (this.product_input) {
        param.set(this.product_select, this.product_input);
      }
      if (page == 1) {
        this.$store.commit("lazada/setProductData", null);
      }
      RequestUtils.request(conf.getProducts(), param).then(json => {
        console.log(json);
        this.$store.commit("lazada/setProductData", json);
      })
    },
    /**
     * 获取更多产品
     * @return {[type]} [description]
     */
    getMoreProduct () {
      return new Promise(resolve => {
        if (this.product.current_page < this.product.last_page) {        
          this.getProduct(this.product.current_page+1);
        }
        resolve();
      });
    },
    /**
     * 置顶产品
     * @param {[type]} item [description]
     */
    setWeight (item) {
      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("item_id", item.item_id);
      RequestUtils.request(conf.setWeight(), param).then(() => {
        this.getProduct();
      })
    },

    /**
     * 订单列表
     * @param  {Number} page [description]
     * @return {[type]}      [description]
     */
    getOrder (page = 1) {
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", this.currentStore.id);
      param.set("buyer_id", this.currentSession.buyer_id);

      if (typeof page != Number || page == 1) {
        this.$store.commit("lazada/setOrderData", null);
      }
      RequestUtils.request(conf.getOrders(), param).then(json => {
        this.$store.commit("lazada/setOrderData", json);
      })
    },
    /**
     * 加载更多订单
     * @return {[type]} [description]
     */
    getMoreOrder() {
      return new Promise(resolve => {
        if (this.order.current_page < this.order.last_page) {        
          this.getOrder(this.order.current_page+1);
        }
        resolve();
      });      
    },
    /**
     * 发送订单
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    order_send (item) {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("session_id", self.currentSession.session_id);
      param.set("template_id", 10007);
      param.set("order_id", item.ordersn);

      param.set("iconUrl", item.products[0]['item_image']);      
      param.set("productName", item.products[0]['item_name']);      
      param.set("status", item.order_status);      
      param.set("content", item.created_at);      
      MsgUtils.request(this, param).then(() => {
        scrollBottom(self, this.chatBoxElem);
      })
    },    
    /**
     * 复制订单信息
     * @param  {[type]} order [description]
     * @return {[type]}       [description]
     */
    buyer_info (order) {
      let skus = new Array();
      for (let i=0; i<order.products.length; i++) {
        skus.push(order.products[i].item_sku);
      }
      let copyValue = '';
      copyValue += order.recipient_info_app.recipient_addr+'\n';
      copyValue += order.ordersn+'\n';
      copyValue += order.recipient_info_app.recipient+'\n';
      copyValue += order.recipient_info_app.recipient_phone+'\n';
      copyValue += order.created_at+'\n';
      copyValue += this.$store.state.lazada.currentStore.name+'\n';
      copyValue += skus.join(',')+'\n';

      this.$copyText(copyValue).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    getVoucher () {
      let self = this;
      self.$store.commit("lazada/setVoucherData", null);

      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("voucher_type", this.voucherType);
      param.set("connector", 'lazada');

      RequestUtils.request(conf.getVoucherList(), param).then(json => {
        self.$store.commit("lazada/setVoucherData", {
          voucher_list: json.data_list
        });
      })
    },
    voucher_send (item) {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("session_id", self.currentSession.session_id);
      param.set("template_id", 10008);
      param.set("promotion_id", item.id);

      param.set("voucherType", item.voucher_type);
      param.set("title", item.voucher_name);
      param.set("discountAmount", item.offering_money_value_off);
      param.set("currency", item.currency);
      param.set("period", self.formatDate(item.period_start_time)+'-'+self.formatDate(item.period_end_time));
      MsgUtils.request(this, param).then(() => {
        scrollBottom(self, this.chatBoxElem);
      })
    },
    addRemark() {
      let param = new FormData();
      let content = this.$refs.remarkEditorElem.getEditorContent();
      if (!content) {
        return this.$Message.error('内容不能为空');
      }
      param.set("connector", 'lazada' );
      param.set("aftersale_id", this.remarkFormItem.aftersale_id );
      param.set("remark", content );
      RequestUtils.request(conf.addRemark(), param)
      .then(() => {            
        this.appendRemarkModalShow(this.remarkFormItem.aftersale_id);    
        this.$refs.remarkEditorElem.clearContent();
      })
    },
    appendRemarkModalShow(aftersale_id) {
      this.appendRemarkModal = true;
      let self = this;
      let param = new FormData();
      param.set("connector", 'lazada' );
      param.set("aftersale_id", aftersale_id );
      RequestUtils.request(conf.getRemarks(), param)
      .then((json) => {            
        self.remarkList = json;
        self.remarkFormItem.aftersale_id = aftersale_id;
      })
      // 获取售后详情
      param = new FormData();
      param.set("connector", 'lazada' );
      param.set("id", aftersale_id );
      RequestUtils.request(conf.salesDetail(), param)
      .then((json) => {       
        self.remarkFormItem.orderStatus = json.status  
        self.remarkFormItem.saleType = json.order_type
      })
    },
    addSalesModalShow(item) {
      this.addSalesModal = true;
      this.salesForm.id = item.ordersn;
    },
    aftersaleAdd() {
      this.addSalesModal = false;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("connector", 'lazada');
      param.set("ordersn", this.salesForm.id);
      param.set("type", this.salesForm.type);
      let content = this.$refs.saleEditorElem.getEditorContent();
      if (!content) {
        return this.$Message.error('内容不能为空');
      }
      param.set("remark", content);

      RequestUtils.request(conf.aftersaleAdd(), param).then(() => {
        this.$Message.success('添加成功!');
        this.salesForm.type = 1;
        this.$refs.saleEditorElem.clearContent();
        this.getOrder();
      })
    },
    // 设置售后状态
    setSaleStatus(value, id) {
      let param = new FormData();
      param.set("id", id );
      param.set('status', value );
      param.set("connector", 'lazada' );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
      })
    },
    // 设置售后类型
    setSaleType(value, id) {
      let param = new FormData();
      param.set("id", id );
      param.set('type', value );
      param.set("connector", 'lazada' );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
      })
    },
    refundConfirm (reverse_order_id) {
      console.log(reverse_order_id);
      var self = this;
        this.$Modal.confirm({
            title: '退款',
            content: '<p>确定退货退款吗</p>',
            onOk: () => {
                let param = new FormData();
                param.set("store_id", self.currentStore.id);
                param.set("reverse_order_id", reverse_order_id);
                param.set("connector", 'lazada');
                RequestUtils.request(conf.refund(), param).then(() => {
                  this.$Message.success('成功');
                })
            },
            onCancel: () => {
            }
        });
    },
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.right-panel-container-list {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .simple-tab{
    height: 40px;
    padding-bottom: 3px;
    width: auto;
    margin: 16px 16px 0;
    display: flex;
    cursor: pointer;
    list-style: none;
    overflow: hidden;
    position: relative;

    .tab-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1 1;
      position: relative;
      text-align: center;
      height: 100%;
      font-weight: 700;
      border-radius: 18px;
    }
    .tab-item.selected {
      color: #07f;
      background-color: rgba(0,29,233,.06);
    }
  }
}

.im-components-btn {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-family: inherit;
  background: transparent;
  cursor: pointer;
  transition: all .3s ease-out;
  box-shadow: none;
  text-align: center;
  border-radius: 4px;
  font-size: 13px;
  flex: 1 1;
}

.im-components-btn-secondary {
  background-color: #fff;
  border-color: rgba(64,112,244,.5);
  color: #4070f4;
}

.im-components-btn.im-components-btn-primary:enabled {
  background-color: #0898ff;
  color: #fff;
}

.im-components-btn-medium {
  margin: 0;
  height: 28px;
  padding: 0 16px;
  line-height: 26px;
  border-width: 1px;
}

.im-components-btn+.im-components-btn {
  margin-left: 16px;
}

.lzd-order-item {
  padding: 0px 12px;

  p {
    font-size: 12px;
  }
  .order-header {
    .header-item-info {
      display: flex;
      justify-content: space-between;
      .header-item-status {
        color: #333;
        font-weight: 700;
      }
      .header-item-createtime {
        color: #888;
        font-size: 12px;
      }
    }
    .header-item-order {
      font-size: 12px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
  .more-item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
  .order-section {
    .section-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      justify-content: space-between;

      .section-item-label {
        font-size: 12px;
        color: #888;
      }
      .section-item-content {
        font-size: 12px;
        color: #000;
      }
    }
  }
  .order-detail {
    .content {
      min-height: 0;
      flex: 1 1;
      position: relative;
      display: flex;
      flex-direction: column;
    }
    .sub-order-item {
      .item__body {
        display: flex;
        .item__pic {
          flex-shrink: 0;
          height: 64px;
          width: 64px;
          border-radius: 4px;
        }
        .item__info {
          flex: 1 1;
          min-width: 0;
          margin-left: 8px;
          font-size: 14px;
          .title {
            margin-bottom: 0;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
          }
          .properties {
            font-size: 12px;
            margin-bottom: 0;
            color: #858b9c;
          }
          .price-info {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            color: #858b9c;
            .price {
              color: #000;
              display: block;
              font-weight: 700;
            }
            .count {
              display: block;
              font-size: 22px;
              transform: scale(.5);
            }
          }
        }
      }
    }
  }
  .reverse-order-wrap {
    .reverse-refund-type {
      color: #ff0000;
    }
    .reverse-order-content {
      padding: 8px;
      background: #f0f8fe;
      border-radius: 3px;
      .operate-wrap {
        display: flex;
        justify-content: space-between;
        .reverse-order-status {
          color: #000;
          font-weight: bold;
        }
        button {
          background: none;
          border: none;
          color: #0898ff;
          cursor: pointer;
        }
      }
      .reverse-order-info-wrap {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        .reverse-order-info {
          p {
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .order-footer {
    padding: 12px 0 0;
    text-align: right;
  }
}

.voucher-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: rgba(214,217,230,.2);
  margin: 4px 16px;
  padding: 9px 12px;
  border-radius: 8px;

  .voucher-item-hd {
    flex-direction: row;
    justify-content: space-between;
    display: flex;

    .im-components-btn {
      flex: none;
    }
    .voucher-item-price {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #f51c43;
      font-weight: 700;

      .im-icon {
        margin-right: 8px;
      }
    }
  }
  .voucher-item-bd {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .voucher-item-line {
      display: block;
      margin: 2px 0;
      font-size: 12px;

      .voucher-item-line__label {
        color: #858b9c;
      }
      .voucher-item-line__field {
        color: #000;
        margin: 0;
      }
    }
  }
}

.productList {
  .item__wrapper {
    padding: 0px 12px;
    width: 29rem;
    box-sizing: border-box;
    .item__info {
      display: flex;
      overflow: hidden;

      .item__pic {
        background-position: 50%;
        background-size: cover;
        flex-shrink: 0;
        width: 56px;
        height: 56px;
        margin-right: 8px;
        margin-left: 0;
        border-radius: 4px;
        background-repeat: no-repeat;
        position: relative;
      }
      .item__desc {
        flex: 1 1;
        margin-right: 10px;

        .item__row {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          margin-top: 4px;
          overflow: hidden;

          .text-overflow {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .item__units {
              flex-shrink: 0;
              color: #858b9c;
              font-size: 12px;
              transform: scale(.9);
            }
          }

          .item__sku {
            color: #000;
          }
        }

        .item__price {
          font-size: 12px;
          font-weight: 700;
          margin-top: 4px;
        }
      }
    }
    .item__ops {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;


    }
  }
}

.content {
  display: flex;

  .lzd-panel-order {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  .lzd-panel-product {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  .im-voucher-section {
    display: flex;
    flex-direction: column;
    flex: 1 1;

    .voucher-tab {
      height: 30px;
      margin: 6px 0;
      padding-bottom: 3px;
      width: auto;
      display: flex;
      cursor: pointer;
      list-style: none;
      overflow: hidden;

      .tab-item {
        background: none;
        font-weight: unset;
      }
      .tab-item:before {
        width: 60%;
        left: 20%;
        height: 2px;
        transform: scaleX(0);
        content: " ";
        position: absolute;
        top: 100%;
        background: #07f;
      }
      .tab-item.selected:before {
        transform: scaleX(1);
      }
    }

    .lzd-fields-tab {
      display: flex;
      overflow: hidden;
      flex: 1 1;

      .lzd-fields-list-box {
        flex: 1 1;
        font-family: HelveticaNeue;
        color: #000;
        font-size: 14px;
        width: 100%;
        position: relative;
        overflow: hidden;

        .list-view {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow-y: auto;
        }

        .empty-default {
          width: 100%;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #8e969c;
          padding-top: 20px;
        }
      }
    }
  }

    .order-info-panel {
      flex: 1 1;
      display: flex;
      flex-direction: column;
    }

    .simple-loader {
      flex: 1 1;

      .simple-placeholder {
        position: relative;
        height: 100%;

        .empty-tip {
          top: 10%;
          width: 66%;
          padding-top: 20px;
          text-align: center;
          position: absolute;
          left: 50%;
          transform: translate(-50%,-50%);

          .no-order-tip {
            color: #8e969c;
          }
        }
      }
    } 
}
.remark-trace {
  display: flex;
  padding-left: 10rem;
  height: 400px;
  overflow: scroll;

  .date-line {
    list-style: none;
    margin-right: 1rem;

    .date-item {
      height: 100px;
      width: 111px;
    }
  }
}
</style>
